import { css } from '@stitches/core';
import { generateClassNames } from '@supabase/auth-ui-shared';
import { createMemo } from 'solid-js';
var containerDefaultStyles = css({
    display: 'flex',
    gap: '4px',
    variants: {
        direction: {
            horizontal: {
                flexDirection: 'row',
                margin: '4px 0'
            },
            vertical: {
                flexDirection: 'column',
                margin: '8px 0'
            }
        },
        gap: {
            small: {
                gap: '4px'
            },
            medium: {
                gap: '8px'
            },
            large: {
                gap: '16px'
            }
        }
    }
});
var Container = function (props) {
    var _a, _b;
    var classNames = createMemo(function () {
        return generateClassNames('container', containerDefaultStyles({
            direction: props.direction,
            gap: props.gap
        }), props.appearance);
    });
    return (<div {...props} style={(_b = (_a = props.appearance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.container} class={classNames().join(' ')}>
      {props.children}
    </div>);
};
export { Container };
